//@flow
import NewPlanWithNewNumber from './NewPlanWithNewNumber';
import { connect } from 'react-redux';
import { hasSubscriptionsToActivateWithoutOptionsSelector } from '../../../../../modules/Subscriptions';
import { isCurrentSubscriptionSelector } from '../../../../../modules/Subscription/selectors';
import type { StateProps } from './NewPlanWithNewNumber';
import type { StateType } from '../../../../../modules/reducers';

const mapStateToProps = (state: StateType): StateProps => ({
  hasSubscriptionsWithNoOptions: hasSubscriptionsToActivateWithoutOptionsSelector(state),
  isCurrentSubscription: subscription => isCurrentSubscriptionSelector(state, subscription),
});

export default connect(mapStateToProps)(NewPlanWithNewNumber);
